import { o as f } from "./query-assigned-elements-B8U94KLQ.js";
import { n as g } from "./property-BWlAHqg_.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function v(t, e, a) {
  let i, o = t;
  return typeof t == "object" ? (o = t.slot, i = t) : i = { flatten: e }, f({ descriptor: (s) => ({ get() {
    var n, c;
    const r = "slot" + (o ? `[name=${o}]` : ":not([name])"), h = (n = this.renderRoot) === null || n === void 0 ? void 0 : n.querySelector(r);
    return (c = h == null ? void 0 : h.assignedNodes(i)) !== null && c !== void 0 ? c : [];
  }, enumerable: !0, configurable: !0 }) });
}
let m = class {
  constructor(t, { target: e, config: a, callback: i, skipInitial: o }) {
    this.t = /* @__PURE__ */ new Set(), this.o = !1, this.i = !1, this.h = t, e !== null && this.t.add(e ?? t), this.l = a, this.o = o ?? this.o, this.callback = i, window.MutationObserver ? (this.u = new MutationObserver((s) => {
      this.handleChanges(s), this.h.requestUpdate();
    }), t.addController(this)) : console.warn("MutationController error: browser does not support MutationObserver.");
  }
  handleChanges(t) {
    var e;
    this.value = (e = this.callback) == null ? void 0 : e.call(this, t, this.u);
  }
  hostConnected() {
    for (const t of this.t) this.observe(t);
  }
  hostDisconnected() {
    this.disconnect();
  }
  async hostUpdated() {
    const t = this.u.takeRecords();
    (t.length || !this.o && this.i) && this.handleChanges(t), this.i = !1;
  }
  observe(t) {
    this.t.add(t), this.u.observe(t, this.l), this.i = !0, this.h.requestUpdate();
  }
  disconnect() {
    this.u.disconnect();
  }
};
var C = Object.defineProperty, p = (t, e, a, i) => {
  for (var o, s = void 0, n = t.length - 1; n >= 0; n--) (o = t[n]) && (s = o(e, a, s) || s);
  return s && C(e, a, s), s;
};
const u = Symbol("assignedNodes");
function O(t, e, a = []) {
  var i, o;
  const s = (c) => (r) => c.matches(r);
  class n extends (o = t, i = u, o) {
    constructor(...r) {
      super(r), this.slotHasContent = !1, new m(this, { config: { characterData: !0, subtree: !0 }, callback: (h) => {
        for (const l of h) if (l.type === "characterData") return void this.manageTextObservedSlot();
      } });
    }
    manageTextObservedSlot() {
      if (!this[u]) return;
      const r = [...this[u]].filter((h) => {
        const l = h;
        return l.tagName ? !a.some(s(l)) : !!l.textContent && l.textContent.trim();
      });
      this.slotHasContent = r.length > 0;
    }
    update(r) {
      if (!this.hasUpdated) {
        const { childNodes: h } = this, l = [...h].filter((b) => {
          const d = b;
          return d.tagName ? !a.some(s(d)) && (e ? d.getAttribute("slot") === e : !d.hasAttribute("slot")) : !!d.textContent && d.textContent.trim();
        });
        this.slotHasContent = l.length > 0;
      }
      super.update(r);
    }
    firstUpdated(r) {
      super.firstUpdated(r), this.updateComplete.then(() => {
        this.manageTextObservedSlot();
      });
    }
  }
  return p([g({ type: Boolean, attribute: !1 })], n.prototype, "slotHasContent"), p([v({ slot: e, flatten: !0 })], n.prototype, i), n;
}
export {
  O,
  v as o,
  m as t
};
//# sourceMappingURL=observe-slot-text-DWmBsDhw.js.map
